// Думите в кутиите на таблото — едни и същи парчета навсякъде, за да стоят
// числата на една линия от кутия до кутия: голямото число с думите след него,
// спокойното изречение („всичко е наред" / „днес няма"), сумата и тревогата.
import type { ReactNode } from "react";
import { formatMoney } from "../../components/numbers";

// Голямото число и думите след него: „3 чакащи отчета"
export const BoxCount = ({ value, label }: { value: ReactNode; label: string }) => (
  <span className="flex min-w-0 flex-wrap items-baseline gap-x-1.5">
    <span className="font-sheet text-[26px] font-semibold leading-none tabular-nums text-ink">
      {value}
    </span>
    <span className="text-[13.5px] leading-[1.3] text-body">{label}</span>
  </span>
);

// „Всичко е наред" — изречение вместо число, в зелено
export const BoxAllClear = ({ text }: { text: string }) => (
  <span className="text-[14px] font-medium leading-[1.3] text-ok-deep">✓ {text}</span>
);

// Неутрално изречение без число („Днес няма изписвания")
export const BoxNote = ({ text }: { text: string }) => (
  <span className="text-[14px] font-medium leading-[1.3] text-body">{text}</span>
);

// Сума в реда под числото — с точка, моноширинна, като в справките
export const BoxMoney = ({ value }: { value: number }) => (
  <span className="font-sheet font-semibold tabular-nums text-ink">{formatMoney(value)}</span>
);

// Частта, която иска внимание („1 закъснял", „1 задържана")
export const BoxAlert = ({ children }: { children: ReactNode }) => (
  <span className="font-medium text-danger-ink">{children}</span>
);
